<template>
  <div class="c-searchBar">
    <div class="c-searchBar__pc" >
      <div class="u-selectWrapper u-w120 u-mR8">
        <select v-model="options.prefcode" @change="onChangeCityList()">
          <option value=0 disabled>都道府県</option>
          <option v-for="(item, index) in preflist" :key="index" :value="item.pref_code">{{item.pref_name}}</option>
        </select>
      </div>
      <div class="u-selectWrapper u-w200">
        <select v-model="options.citycode" v-bind:disabled="!isCityListReady">
          <option value=0 disabled>市区町村選択</option>
          <option v-for="(item, index) in citylist" :key="index" :value="item.city_code">{{item.city_name}}</option>
        </select>
      </div>
      <div class="u-buttonWrapper">
        <common-button
          style="margin-left:10px;"
          :title="'価格帯'"
          :border_gray="true"
          :small="true"
          :callback="onClickToggleModal"
          :attr=[0] />
        <!-- <button @click="onClickToggleModal(0)">価格帯</button> -->
        <div v-if="isDisplayPrice" class="u-buttonWrapper--modal u-buttonWrapper--modal__m">
          <div>
            <div class="u-modal--select">
              <select v-model="options.priceLow">
                <option v-for="(item, index) in optionList.priceLow" :value="item.value" :key="index">{{item.name}}</option>
              </select>
            </div>
            〜
            <div class="u-modal--select">
              <select v-model="options.priceHigh">>
                <option v-for="(item, index) in optionList.priceHigh" :value="item.value" :key="index">{{item.name}}</option>
              </select>
            </div>
          </div>
          <input type="checkbox" id="price" class="" v-model="options.ask"> <label for="price" style="font-size: 12px;">価格帯に価格未定の設定を含める</label>
        </div>
      </div>
      <div class="u-buttonWrapper">
        <common-button
          style="margin-left:10px;"
          :title="'間取り'"
          :border_gray="true"
          :small="true"
          :callback="onClickToggleModal"
          :attr=[1] />
        <!-- <button @click="onClickToggleModal(1)">間取り</button> -->
        <div v-if="isDisplayLayout" class="u-buttonWrapper--modal">
          <ul class="u-modal--checkbox">
            <li v-for="(item, index) in optionList.layout" :key="index">
              <input type="checkbox" :id="`layout-${item.value}`" v-model="options.layout" :value="item.value" style="display:none;" />
              <label :for="`layout-${item.value}`" :class="{ 'u-modal--checkbox__on': options.layout.includes(item.value)}">{{item.name}}</label>
            </li>
          </ul>
        </div>
      </div>
      <div class="u-buttonWrapper">
        <common-button
          style="margin-left:10px;"
          :title="'土地面積'"
          :border_gray="true"
          :small="true"
          :callback="onClickToggleModal"
          :attr=[2] />
        <!-- <button @click="onClickToggleModal(2)">土地面積</button> -->
        <div v-if="isDisplayLand" class="u-buttonWrapper--modal u-buttonWrapper--modal__m">
          <div>
            <div class="u-modal--select">
              <select v-model="options.landAreaLow">
                <option v-for="(item, index) in optionList.areaLow" :value="item.value" :key="index">{{item.name}}</option>
              </select>
            </div>
            〜
            <div class="u-modal--select">
              <select v-model="options.landAreaHigh">
                <option v-for="(item, index) in optionList.areaHigh" :value="item.value" :key="index">{{item.name}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="u-buttonWrapper">
        <common-button
          style="margin-left:10px;"
          :title="'建物面積'"
          :border_gray="true"
          :small="true"
          :callback="onClickToggleModal"
          :attr=[3] />
        <!-- <button @click="onClickToggleModal(3)">建物面積</button> -->
        <div v-if="isDisplayBuilding" class="u-buttonWrapper--modal u-buttonWrapper--modal__m">
          <div>
            <div class="u-modal--select">
              <select v-model="options.buildingAreaLow">
                <option v-for="(item, index) in optionList.areaLow" :value="item.value" :key="index">{{item.name}}</option>
              </select>
            </div>
            〜
            <div class="u-modal--select">
              <select v-model="options.buildingAreaHigh">
                <option v-for="(item, index) in optionList.areaHigh" :value="item.value" :key="index">{{item.name}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="u-buttonWrapper">
        <common-button
          style="margin-left:10px;"
          :title="'徒歩'"
          :border_gray="true"
          :small="true"
          :callback="onClickToggleModal"
          :attr=[4] />
        <!-- <button @click="onClickToggleModal(4)">徒歩</button> -->
        <div v-if="isDisplayWalk" class="u-buttonWrapper--modal u-buttonWrapper--modal__m">
          <div>
            <div class="u-modal--select u-modal--select__l">
              <select v-model="options.walkin">
                <option v-for="(item, index) in optionList.walkin" :value="item.value" :key="index">{{item.name}}</option>
                <option value=999>上限なし</option>
              </select>
            </div>
          </div>
          <input type="checkbox" id="byBus" class="" v-model="options.byBus"><label for="byBus" style="font-size: 12px;">徒歩分にバス乗車時間含む</label>
        </div>
      </div>
      <div class="u-inputWrapper">
        <input type="text"  v-model="options.fw" placeholder="フリーワード検索" />
      </div>
      <common-button
        style="margin-left:10px;"
        :callback="update"
        :title="buttonText"
        :attr=[]
        :bg_red="true"
        :small="true" />
      <div class="p-gotoBottom">
        <button @click="clickSmoothScroll">市区町村から探す</button>
      </div>
    </div>
  </div>
</template>

<script>
import MixinAPI from '@/plugins/mixin-api';
import MixinSearchbar from '@/plugins/mixin-searchbar';
import CommonButton from '@/components/parts/button/CommonButton';

export default {
  name: 'SearchBarPC',
  mixins: [MixinAPI, MixinSearchbar],
  components: {
    CommonButton,
  },
  methods: {
    clickSmoothScroll() {
      document.querySelector('.js-search-list').scrollTo({
        top: 100000,
        behavior: 'smooth',
      });
    },
  },
};

</script>

<style scoped lang="scss">
@import "@/assets/style/searchbar_scss.scss";
.p-gotoBottom {
  margin-left:auto;
  margin-right:20px;
  button {
    width: 220px;
    height: 40px;
    margin: auto;
    border: 1px solid #CCC;
    border-radius: 20px;
    display:flex;
    justify-content: center;
    align-items: center;
    position: relative;
    background-color: #FFF;
  }
  button:after {
    content: '';
    background-image: url('/static/img/icon-arrow.png');
    background-size: cover;
    transform:rotateZ(90deg);
    position: absolute;
    width: 18px;
    height: 18px;
    top:10px;
    right:25px;
  }
}


</style>
